<template>
  <base-layout login-view>
    <template v-slot:game-content>
      <div class="container-fluid login">
        <div class="login-card">
          <img
            alt="Save The City"
            class="login-card__image img-fluid"
            src="@/core/assets/game-logo.png"
          />
          <div class="login-card-checkbox-area">
            <div
              :class="{ error: validatedForm && !termsConditions }"
              class="login-card-checkbox-control"
            >
              <b-form-checkbox v-model="termsConditions" type="checkbox">
                {{ $t('accept_terms_and_conditions') }}<br />
                <a :href="constants.TERMS_CONDITIONS_URL" target="_blank">
                  <span>{{ $t('terms_and_conditions') }}</span>
                </a>
              </b-form-checkbox>
            </div>
            <div
              :class="{ error: validatedForm && !termsConditions }"
              class="login-card-checkbox-error"
            >
              <span v-show="validatedForm && !termsConditions">
                {{ $t('accept_terms_to_continue') }}
              </span>
            </div>
            <div
              :class="{ error: validatedForm && !privacyPolicy }"
              class="login-card-checkbox-control"
            >
              <b-form-checkbox v-model="privacyPolicy" type="checkbox">
                {{ $t('accept_privacy_policy') }}<br />
                <a :href="constants.PRIVACY_POLICY_URL" target="_blank">
                  <span>{{ $t('privacy_policy') }}</span>
                </a>
              </b-form-checkbox>
            </div>
            <div
              :class="{ error: validatedForm && !privacyPolicy }"
              class="login-card-checkbox-error"
            >
              <span v-show="validatedForm && !privacyPolicy">
                {{ $t('accept_policy_to_continue') }}.
              </span>
              <span v-if="errorMessage">
                {{ errorMessage }}
              </span>
            </div>
          </div>
          <b-button
            :disabled="disabledButton"
            variant="primary"
            @click="createGame()"
          >
            {{ $t('create_game') }}
          </b-button>
        </div>
      </div>
    </template>
  </base-layout>
</template>

<script>
import { ref } from '@vue/composition-api';
import { BaseLayout } from '@/core/components';
import { Game } from '@/core/services';
import { Constants } from '@/core/utils';

export default {
  name: 'LoginView',
  components: { BaseLayout },
  setup(props, { root }) {
    const termsConditions = ref(false);
    const privacyPolicy = ref(false);
    const validatedForm = ref(false);
    const errorMessage = ref('');
    const constants = Constants;
    const disabledButton = ref(false);

    const createGame = () => {
      validatedForm.value = true;

      if (!termsConditions.value || !privacyPolicy.value) return false;

      const dataForm = {
        privacyPolicy: privacyPolicy.value,
        termsConditions: termsConditions.value,
      };

      disabledButton.value = true;
      Game.createGame(dataForm)
        .then((response) => {
          Game.clearStorageGame();
          Game.setStorageGame(response.game);

          setTimeout(() => {
            root.$router.push({ name: 'home' });
            disabledButton.value = false;
          }, 1000);
        })
        .catch((err) => {
          disabledButton.value = false;
          validatedForm.value = false;
          errorMessage.value = 'Unexpected error, please try again.';

          if (err) {
            if (err.message) {
              errorMessage.value = err.message;
            }
          }
        });
    };

    return {
      termsConditions,
      privacyPolicy,
      disabledButton,
      validatedForm,
      errorMessage,
      constants,
      createGame,
    };
  },
};
</script>

<style lang="scss">
@import '~@/core/styles/variables.scss';
@import '~@/core/styles/mixins.scss';

.login {
  @include flexbox(center, center);
  height: calc(100vh - 84px);
  padding: 180px 0 104px 0;

  @media (max-height: 576px) {
    height: 100%;
    padding: 90px 0 40px 0;
  }

  &-card {
    @include flexbox(center, center, column);
    background-color: $bg-card-login;
    border: 5px solid $border-card-login;
    border-radius: 30px;
    width: 380px;
    height: 400px;
    padding: 0 30px;

    &__image {
      width: 248px;
      margin-top: -105px;
    }

    &-checkbox-area {
      padding-top: 45px;
      padding-bottom: 40px;

      // If I put 'scoped' on this stylesheet,
      // it does not allow this class below to accept the styles.

      .custom-control-label {
        padding-top: 7px;
        @include font-button($color-purple);
      }
    }

    &-checkbox-control {
      &.error {
        border: 3px solid $color-red;
        border-radius: 7px;
        padding: 5px 10px 0 7px;
      }
    }

    &-checkbox-error {
      @include font-text-error();
      margin-bottom: 25px;
      &.error {
        margin-bottom: 15px;
      }
    }
  }
}
</style>
